import { render, staticRenderFns } from "./MpnPageTitle.vue?vue&type=template&id=08edad5a&"
import script from "./MpnPageTitle.vue?vue&type=script&lang=js&"
export * from "./MpnPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports